var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progressbar"},[_c('div',{staticClass:"tip",style:({
        left: `${_vm.value}%`,
      })},[_c('count-to',{attrs:{"start-val":0,"end-val":_vm.value,"duration":0.3}}),_vm._v("% ")],1),_c('div',{staticClass:"bar",style:({
        width: `${_vm.value}%`,
      })})]),_c('div',{staticClass:"desc"},[_c('div',{staticClass:"start"},[_vm._t("start")],2),_c('div',{staticClass:"end"},[_vm._t("end")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }